import {
  actionTypes,
  CommercialActiveUserProps,
  CommercialDateRangeInput,
  CommercialUserProfileProps,
  CommercialUserProps,
  CommerciaSignUpInput,
  FilterUserInput,
  FilterUserProps,
  RegisteredCommercialUserProps,
} from "./actionType";
import { executeMutation, executeQuery } from "utils/services/apiServices";
import { showSnackbar } from "utils/snack_bar/store/action";
import { setError } from "utils/flash_error/store/action";
import {
  CHECK_EXISTING_COMMERCIAL_USER,
  FETCH_ALL_COMMERCIAL_ACTIVE_USERS,
  FETCH_ALL_COMMERCIAL_USERS,
  FETCH_COMMERCIAL_NEW_REGISTER,
  FETCH_COMMERCIAL_PROFILE_BY_USER_ID,
  FETCH_COMMERCIAL_USER_BY_ID,
} from "../graphql/query";
import {
  CREATE_COMMERCIAL_USER,
  RESET_COMMERCIAL_USER_PASSWORD,
  UPDATE_COMMERCIAL_USER,
  UPDATE_COMMERCIAL_USER_STATUS,
} from "../graphql/mutation";

export interface CheckExistingResult {
  available: boolean;
  message?: string;
}
export interface MutationResult {
  success: boolean;
  message?: string;
}

export const fetchCommercialUsersRequest = () => ({
  type: actionTypes.FETCH_COMMERCIAL_USERS_REQUEST,
});
export const fetchCommercialUsersSuccess = (
  payload: CommercialUserProps[]
) => ({
  type: actionTypes.FETCH_COMMERCIAL_USERS_SUCCESS,
  payload,
});
export const fetchCommercialUsersFail = (payload: string) => ({
  type: actionTypes.FETCH_COMMERCIAL_USERS_FAIL,
  payload,
});
export const fetchCommercialUsers = (limit:number, offset:number) => {
  return async (dispatch: any) => {
    try {
      await dispatch(fetchCommercialUsersRequest());
      const response = await executeQuery(FETCH_ALL_COMMERCIAL_USERS, {limit, offset});
      const jsonData = response.data?.fetchAllCommercialUsers;
      if (jsonData?.error === null) {
        dispatch(fetchCommercialUsersSuccess(jsonData?.data.users));
      } else {
        dispatch(fetchCommercialUsersFail(jsonData?.error.message));
      }
    } catch (error: any) {
      dispatch(fetchCommercialUsersFail("Failed to fetch commercial users"));
    }
  };
};
//fetchDcddUserUsingUserById
export const fetchCommercialUserRequest = () => ({
  type: actionTypes.FETCH_COMMERCIAL_USER_BY_ID_REQUEST,
});
export const fetchCommercialUserSuccess = (payload: CommercialUserProps) => ({
  type: actionTypes.FETCH_COMMERCIAL_USER_BY_ID_SUCCESS,
  payload,
});
export const fetchCommercialUserFail = (payload: string) => ({
  type: actionTypes.FETCH_COMMERCIAL_USER_BY_ID_FAIL,
  payload,
});
export const fetchCommercialUser = (user_id: string) => {
  return async (dispatch: any) => {
    try {
      const input_Data = {
        user_id: user_id,
      };
      await dispatch(fetchCommercialUserRequest());
      const response = await executeQuery(
        FETCH_COMMERCIAL_USER_BY_ID,
        input_Data
      );
      const jsonData = response.data?.fetchUser;
      if (jsonData?.error === null) {
        dispatch(fetchCommercialUserSuccess(jsonData?.data.user));
        dispatch(showSnackbar("Success! user fetched"));
      } else {
        dispatch(fetchCommercialUserFail(jsonData?.error.message));
        dispatch(showSnackbar(`Error:${jsonData?.error.message}`));
      }
    } catch (error: any) {
      dispatch(fetchCommercialUserFail("Failed to fetch commercial user"));
    }
  };
};
//fetchDcddUserUsingUserProfileId
export const fetchCommercialUserProfileByIdRequest = () => ({
  type: actionTypes.FETCH_COMMERCIAL_USER_PROFILE_BY_USER_ID_REQUEST,
});
export const fetchCommercialUserProfileByIdSuccess = (
  payload: CommercialUserProfileProps
) => ({
  type: actionTypes.FETCH_COMMERCIAL_USER_PROFILE_BY_USER_ID_SUCCESS,
  payload,
});
export const fetchCommercialUserProfileByIdFail = (payload: string) => ({
  type: actionTypes.FETCH_COMMERCIAL_USER_PROFILE_BY_USER_ID_FAIL,
  payload,
});
export const fetchCommercialUserProfileById = (user_id: string) => {
  return async (dispatch: any) => {
    try {
      const input_Data = {
        user_id: user_id,
      };
      await dispatch(fetchCommercialUserProfileByIdRequest());
      const response = await executeQuery(
        FETCH_COMMERCIAL_PROFILE_BY_USER_ID,
        input_Data
      );
      const jsonData = response.data?.fetchProfileByCommercialUserId;
      if (jsonData?.error === null) {
        dispatch(
          fetchCommercialUserProfileByIdSuccess(jsonData?.data.user_profile)
        );
        dispatch(showSnackbar("Success! user fetched"));
      } else {
        dispatch(fetchCommercialUserProfileByIdFail(jsonData?.error.message));
        dispatch(showSnackbar(`Error:${jsonData?.error.message}`));
      }
    } catch (error: any) {
      dispatch(
        fetchCommercialUserProfileByIdFail("Failed to fetch user profile")
      );
    }
  };
};

//CheckForExistingDcddUserByMobile
export const checkForExistingCommercialUserByMobileResuest = () => ({
  type: actionTypes.CHECK_FOR_EXISTING_COMMERCIAL_USER_BY_MOBILE_REQUEST,
});
export const checkForExistingCommercialUserByMobileSuccess = () => ({
  type: actionTypes.CHECK_FOR_EXISTING_COMMERCIAL_USER_BY_MOBILE_SUCCESS,
});
export const checkForExistingCommercialUserByMobileFail = (
  payload: string
) => ({
  type: actionTypes.CHECK_FOR_EXISTING_COMMERCIAL_USER_BY_MOBILE_FAIL,
  payload,
});
export const checkForExistingCommercialUserByMobile = (data: String) => {
  return async (dispatch: any): Promise<CheckExistingResult> => {
    try {
      await dispatch(checkForExistingCommercialUserByMobileResuest());
      const input = {
        field: "mobile_no",
        value: data,
      };
      const response = await executeQuery(
        CHECK_EXISTING_COMMERCIAL_USER,
        input
      );
      const jsonData = response.data?.checkForExistingCommercialUser;
      if (jsonData?.error === null && !jsonData?.data.exist_user) {
        dispatch(checkForExistingCommercialUserByMobileSuccess());
        return { available: true };
      }
      const message =
        jsonData?.error?.message ?? "User with given mobile no already exist";
      dispatch(setError(message));
      dispatch(checkForExistingCommercialUserByMobileFail(message));
      return { available: false, message };
    } catch (error: any) {
      dispatch(
        checkForExistingCommercialUserByMobileFail("Something went wrong")
      );
      return { available: false, message: "Something went wrong" };
    }
  };
};

//fetchcommercialActive User
export const fetchCommercialActiveUsersRequest = () => ({
  type: actionTypes.FETCH_COMMERCIAL_ACTIVE_USERS_REQUEST,
});
export const fetchCommercialActiveUsersSuccess = (
  payload: CommercialActiveUserProps[]
) => ({
  type: actionTypes.FETCH_COMMERCIAL_ACTIVE_USERS_SUCCESS,
  payload,
});
export const fetchCommercialActiveUsersFail = (payload: string) => ({
  type: actionTypes.FETCH_COMMERCIAL_ACTIVE_USERS_FAIL,
  payload,
});
export const fetchCommercialActiveUsers = (limit:number, offset:number) => {
  return async (dispatch: any) => {
    try {
      await dispatch(fetchCommercialActiveUsersRequest());
      const response = await executeQuery(FETCH_ALL_COMMERCIAL_ACTIVE_USERS, {limit, offset});
      const jsonData = response.data?.getUserActivity;
      if (jsonData?.error === null) {
        dispatch(fetchCommercialActiveUsersSuccess(jsonData?.data?.grouped_user_activities));
      } else {
        dispatch(fetchCommercialActiveUsersFail(jsonData?.error.message));
      }
    } catch (error: any) {
      dispatch(
        fetchCommercialActiveUsersFail("Failed to fetch active commercial user")
      );
    }
  };
};

//CheckForExistingDcddUserByEmail
export const checkForExistingCommercialUserByEmailResuest = () => ({
  type: actionTypes.CHECK_FOR_EXISTING_COMMERCIAL_USER_BY_EMAIL_REQUEST,
});
export const checkForExistingCommercialUserByEmailSuccess = () => ({
  type: actionTypes.CHECK_FOR_EXISTING_COMMERCIAL_USER_BY_EMAIL_SUCCESS,
});
export const checkForExistingCommercialUserByEmailFail = (payload: string) => ({
  type: actionTypes.CHECK_FOR_EXISTING_COMMERCIAL_USER_BY_EMAIL_FAIL,
  payload,
});
export const checkForExistingCommercialUserByEmail = (data: string) => {
  return async (dispatch: any): Promise<CheckExistingResult> => {
    try {
      await dispatch(checkForExistingCommercialUserByEmailResuest());
      const input = {
        field: "email",
        value: data,
      };
      const response = await executeQuery(
        CHECK_EXISTING_COMMERCIAL_USER,
        input
      );
      const jsonData = response.data?.checkForExistingCommercialUser;
      if (jsonData?.error === null && !jsonData?.data.exist_user) {
        dispatch(checkForExistingCommercialUserByEmailSuccess());
        return { available: true };
      }
      const message =
        jsonData?.error?.message ?? "User with given email already exist";
      dispatch(checkForExistingCommercialUserByEmailFail(message));
      return { available: false, message };
    } catch (error: any) {
      dispatch(
        checkForExistingCommercialUserByEmailFail("Something went wrong")
      );
      return { available: false, message: "Something went wrong" };
    }
  };
};

//FetchCommercialNewRegister
export const fetchCommercialNewRegisterRequest = () => ({
  type: actionTypes.FETCH_COMMERCIAL_NEW_REGISTER_REQUEST,
});
export const fetchCommercialNewRegisterSuccess = (
  payload: CommercialUserProps[]
) => ({
  type: actionTypes.FETCH_COMMERCIAL_NEW_REGISTER_SUCCESS,
  payload,
});
export const fetchCommercialNewRegisterFail = (payload: string) => ({
  type: actionTypes.FETCH_COMMERCIAL_NEW_REGISTER_FAIL,
  payload,
});
export const fetchCommercialNewRegister = (from_date:string,to_date:string) => {
  return async (dispatch: any) => {
    try {
      const input_data:CommercialDateRangeInput ={
        from_date:from_date,
        to_date:to_date
      }
      await dispatch(fetchCommercialNewRegisterRequest());
      const response = await executeQuery(FETCH_COMMERCIAL_NEW_REGISTER, input_data);
      const jsonData = response.data?.fetchCommercialNewRegister;
      if (jsonData?.error === null) {
        dispatch(fetchCommercialNewRegisterSuccess(jsonData?.data.users));
        dispatch(showSnackbar("Success! User created."));
      } else {
        dispatch(fetchCommercialNewRegisterFail(jsonData?.error.message));
        dispatch(
          showSnackbar(
            `Error :${
              jsonData?.error.message
                ? jsonData?.error.message
                : "Something went wrong"
            }`
          )
        );
      }
    } catch (error: any) {
      dispatch(
        fetchCommercialNewRegisterFail(
          "Failed to fetch commercial new register"
        )
      );
    }
  };
};

//createCommercialUser
export const createCommercialUserRequest = () => ({
  type: actionTypes.CREATE_COMMERCIAL_USER_REQUEST,
});
export const createCommercialUserSuccess = (payload: CommercialUserProps) => ({
  type: actionTypes.CREATE_COMMERCIAL_USER_SUCCESS,
  payload,
});
export const createCommercialUserFail = (payload: string) => ({
  type: actionTypes.CREATE_COMMERCIAL_USER_FAIL,
  payload,
});
export const createCommercialUser = (signup_input: CommerciaSignUpInput) => {
  return async (dispatch: any): Promise<MutationResult> => {
    try {
      const input_data = {
        signup_input: signup_input,
      };
      dispatch(createCommercialUserRequest());
      const response = await executeMutation(
        CREATE_COMMERCIAL_USER,
        input_data
      );
      const jsonData = response.data?.createCommercialUser;
      if (jsonData?.error === null) {
        // the mutation returns the user and its profile side by side, but the
        // table reads the name off user_profile
        dispatch(
          createCommercialUserSuccess({
            ...jsonData?.data.user,
            user_profile: jsonData?.data.profile,
          })
        );
        dispatch(showSnackbar("Success! User created."));
        return { success: true };
      }
      const message = jsonData?.error?.message ?? "Something went wrong";
      dispatch(createCommercialUserFail(message));
      dispatch(showSnackbar(`Error :${message}`));
      return { success: false, message };
    } catch (error: any) {
      const message = error?.message ?? "Failed to create commercial user.";
      dispatch(createCommercialUserFail(message));
      dispatch(showSnackbar(`Error :${message}`));
      return { success: false, message };
    }
  };
};

//updateCommercialUser
export const updateCommercialUserRequest = () => ({
  type: actionTypes.UPDATE_COMMERCIAL_USER_REQUEST,
});
export const updateCommercialUserSuccess = (payload: CommercialUserProps) => ({
  type: actionTypes.UPDATE_COMMERCIAL_USER_SUCCESS,
  payload,
});
export const updateCommercialUserFail = (payload: string) => ({
  type: actionTypes.UPDATE_COMMERCIAL_USER_FAIL,
  payload,
});
export const updateCommercialUser = (
  user_id: string,
  signup_input: CommerciaSignUpInput
) => {
  return async (dispatch: any) => {
    try {
      const input_data = {
        user_id: user_id,
        signup_input: signup_input,
      };
      dispatch(updateCommercialUserRequest());
      const response = await executeMutation(
        UPDATE_COMMERCIAL_USER,
        input_data
      );
      const jsonData = response.data?.updateCommercialUser;
      if (jsonData?.error === null) {
        dispatch(updateCommercialUserSuccess(jsonData?.data.user)); // Use the user object
        dispatch(showSnackbar("Success! User created."));
      } else {
        dispatch(updateCommercialUserFail(jsonData?.error.message));
        dispatch(
          showSnackbar(
            `Error :${
              jsonData?.error.message
                ? jsonData?.error.message
                : "Something went wrong"
            }`
          )
        );
      }
    } catch (error: any) {
      dispatch(updateCommercialUserFail("Failed to update commercial user."));
    }
  };
};

//updateCommercialUserStatus
export const updateCommercialUserStatusRequest = () => ({
  type: actionTypes.UPDATE_COMMERCIAL_USER_STATUS_REQUEST,
});
export const updateCommercialUserStatusSuccess = (
  payload: CommercialUserProps
) => ({
  type: actionTypes.UPDATE_COMMERCIAL_USER_STATUS_SUCCESS,
  payload,
});
export const updateCommercialUserStatusFail = (payload: string) => ({
  type: actionTypes.UPDATE_COMMERCIAL_USER_STATUS_FAIL,
  payload,
});
export const updateCommercialUserStatus = (userID: string, status: string) => {
  return async (dispatch: any) => {
    try {
      const input_data = {
        userID: userID,
        status: status,
      };
      dispatch(updateCommercialUserStatusRequest());
      const response = await executeMutation(
        UPDATE_COMMERCIAL_USER_STATUS,
        input_data
      );
      const jsonData = response.data?.updateCommercialUserStatus;
      if (jsonData?.error === null) {
        dispatch(updateCommercialUserStatusSuccess(jsonData?.data.user));
        dispatch(showSnackbar("Success! User created."));
      } else {
        dispatch(updateCommercialUserStatusFail(jsonData?.error.message));
        dispatch(
          showSnackbar(
            `Error :${
              jsonData?.error.message
                ? jsonData?.error.message
                : "Something went wrong"
            }`
          )
        );
      }
    } catch (error: any) {
      dispatch(
        updateCommercialUserStatusFail(
          "Failed to update commercial user status."
        )
      );
    }
  };
};

//resetCommercialUserPassword
export const resetCommercialUserPasswordRequest = () => ({
  type: actionTypes.UPDATE_COMMERCIAL_USER_STATUS_REQUEST,
});
export const resetCommercialUserPasswordSuccess = (payload: string) => ({
  type: actionTypes.UPDATE_COMMERCIAL_USER_STATUS_SUCCESS,
  payload,
});
export const resetCommercialUserPasswordFail = (payload: string) => ({
  type: actionTypes.UPDATE_COMMERCIAL_USER_STATUS_FAIL,
  payload,
});
export const resetCommercialUserPassword = (
  password: string,
  confirm_password: string,
  user_id: string
) => {
  return async (dispatch: any) => {
    try {
      const input_data = {
        password: password,
        confirm_password: confirm_password,
        user_id: user_id,
      };
      dispatch(resetCommercialUserPasswordRequest());
      const response = await executeMutation(
        RESET_COMMERCIAL_USER_PASSWORD,
        input_data
      );
      const jsonData = response.data?.resetCommercialPassword;
      if (jsonData?.error === null) {
        dispatch(resetCommercialUserPasswordSuccess(jsonData?.data.message)); // Use the user object
        dispatch(showSnackbar("Success! User reset."));
      } else {
        dispatch(resetCommercialUserPasswordFail(jsonData?.error.message));
        dispatch(
          showSnackbar(
            `Error :${
              jsonData?.error.message
                ? jsonData?.error.message
                : "Something went wrong"
            }`
          )
        );
      }
    } catch (error: any) {
      dispatch(resetCommercialUserPasswordFail("Failed to reset user."));
    }
  };
};

//RESET
export const ResetCommercialUserDetails = () => ({
  type: actionTypes.RESET_COMMERCIAL_DETAILS,
});

export const resetCommercialUserDetails = () => {
  return async (dispatch: any) => {
    dispatch(ResetCommercialUserDetails());
  };
};


export const filterUserResuest = () => ({
  type: actionTypes.FILTER_USER_REQUEST,
});
export const filterUserSuccess = (payload:FilterUserProps) => ({
  type: actionTypes.FILTER_USER_SUCCESS,
  payload
});
export const filterUserFail = (payload: string) => ({
  type: actionTypes.FILTER_USER_FAIL,
  payload,
});
export const filterUser = (input: FilterUserInput) => {
  return async (dispatch: any) => {
    try {
      await dispatch(filterUserResuest());
      const response = await executeQuery(
        CHECK_EXISTING_COMMERCIAL_USER,
        input
      );
      const jsonData = response.data?.checkForExistingCommercialUser;
      if (jsonData?.error === null) {
        dispatch(filterUserSuccess(jsonData?.data));
      } else {
        dispatch(
          filterUserFail(
            jsonData?.error?.message ?? "No user found"
          )
        );
      }
    } catch (error: any) {
      dispatch(
        filterUserFail("Something went wrong")
      );
    }
  };
};